import { useMutation } from "urql";
import {
  DeleteSongbookMutationMutation,
  DeleteSongbookMutationMutationVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useDeleteSongbookMutation() {
  return useMutation(deleteSongbookMutation);
}

export const deleteSongbookMutation: TypedDocumentNode<
  DeleteSongbookMutationMutation,
  DeleteSongbookMutationMutationVariables
> = graphql(`
  mutation deleteSongbookMutation($id: ID!, $bucket: String!) {
    deleteSongbook(id: $id, bucket: $bucket)
  }
`);
